module.exports = __webpack_public_path__ + "img/qyjbzl.6fda6b56.png";